module.exports = __webpack_public_path__ + "static/media/logo@3x.40247e65.png";